import type { Component } from 'solid-js';
import { Portal } from 'solid-js/web';
import { log, warn } from '../../utils/console';

export interface ShareModalProps {
  shareUrl: string;
  onClose: () => void;
}

const ShareModal: Component<ShareModalProps> = (props) => {
  const handleCopy = async () => {
    const url = props.shareUrl;
    if (!url) {
      warn('[ShareModal] No URL to copy');
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      log('[ShareModal] URL copied to clipboard');
    } catch (e) {
      warn('[ShareModal] clipboard write failed', e);
    }
  };

  return (
    <Portal
      mount={
        typeof document !== 'undefined'
          ? document.getElementById('main-content') || document.body
          : undefined
      }
    >
      <div class="pagesettings-overlay" onClick={() => props.onClose()}>
        <div class="pagesettings-modal share-modal" onClick={(e) => e.stopPropagation()}>
          <div class="share-modal-header">
            <h2 class="share-modal-title">Share Page</h2>
            <button
              type="button"
              class="share-modal-close"
              onClick={() => props.onClose()}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <div class="share-modal-body">
            <div class="share-modal-url-row">
              <input
                type="text"
                class="share-modal-input form-control"
                readonly
                value={props.shareUrl}
                aria-readonly="true"
              />
              <button
                type="button"
                class="share-copy-btn"
                onClick={() => void handleCopy()}
                title="Copy link"
                aria-label="Copy link"
              >
                <svg
                  class="share-copy-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default ShareModal;
